/** AT03 copy (one group per control; a ticket edits only its own file). */
export const at03PtBr = {
  title: 'Depreciação devida e cadastro contra o razão',
  description:
    'Parcelas de depreciação e amortização devidas no período contra o lançado, e custo e depreciação acumulada do cadastro contra o livro.',
  prerequisite:
    'Requer a comparação das parcelas devidas e dos saldos do cadastro com o razão do livro.',
  reasons: {
    DUE_INSTALMENT_NOT_POSTED: 'Parcela devida não lançada',
    RESIDUAL_FLOOR_SUSPENSION_INVALID: 'Suspensão por valor residual não é mais válida',
    POSTED_INSTALMENT_WITHOUT_JOURNAL: 'Parcela marcada como lançada sem lançamento contábil',
    JOURNAL_AMOUNT_DIFFERS_FROM_SCHEDULE: 'Valor lançado difere da parcela',
    DUE_INSTALMENT_REVERSED_NOT_REPLACED: 'Parcela devida estornada e não relançada',
    SCHEDULE_TOTAL_DIFFERS_FROM_BASE: 'Cronograma não soma a base depreciável',
    REGISTER_ABOVE_LEDGER: 'Cadastro acima do razão',
    REGISTER_BELOW_LEDGER: 'Cadastro abaixo do razão',
  },
  observations: {
    AT03_SCOPE_UNRESOLVED: 'Moeda funcional ou período do livro não resolvidos',
    AT03_PENDING_BEFORE_PERIOD: 'Parcelas pendentes de competências anteriores',
    AT03_PENDING_NOT_YET_DUE: 'Parcelas da próxima competência, ainda não devidas',
    AT03_MEMO_INSTALMENTS_MEASURED: 'Parcelas calculadas em livros memoriais, sem lançamento',
    AT03_ACCOUNT_UNMAPPED: 'Bens sem conta de custo ou de depreciação mapeada',
    AT03_REGISTER_COST_UNMEASURABLE: 'Bens cujo custo no livro não pôde ser medido',
    AT03_LEDGER_ACCOUNT_RESTRICTED: 'Contas protegidas fora da comparação',
    AT03_JOURNAL_RESTRICTED: 'Parcelas com lançamento protegido fora da comparação',
    AT03_REGISTER_NOT_MEASURABLE_AT_CUTOFF:
      'Bens alterados depois do fim do período, fora da comparação com o razão',
    AT03_FOREIGN_CURRENCY_NOT_MEASURED:
      'Valores de bens medidos em outra moeda, sem valor na moeda funcional',
    AT03_SCHEDULE_BASE_UNDETERMINED:
      'Réguas de bens migrados sem como saber se a base inclui a depreciação de abertura',
  },
  asset: 'Bem {{code}}',
  account: 'Conta {{code}}',
  openAsset: 'Abrir bem',
  listTruncated: 'Mostrando {{shown}} de {{total}} apontamentos.',
};

export const at03En: typeof at03PtBr = {
  title: 'Due depreciation and register against the ledger',
  description:
    'Depreciation and amortization instalments due in the period against what was posted, and register cost and accumulated depreciation against the book.',
  prerequisite:
    'Needs the due instalments and the register balances compared with the book ledger.',
  reasons: {
    DUE_INSTALMENT_NOT_POSTED: 'Due instalment not posted',
    RESIDUAL_FLOOR_SUSPENSION_INVALID: 'Residual-floor suspension is no longer valid',
    POSTED_INSTALMENT_WITHOUT_JOURNAL: 'Instalment marked as posted with no journal',
    JOURNAL_AMOUNT_DIFFERS_FROM_SCHEDULE: 'Posted amount differs from the instalment',
    DUE_INSTALMENT_REVERSED_NOT_REPLACED: 'Due instalment reversed and not posted again',
    SCHEDULE_TOTAL_DIFFERS_FROM_BASE: 'Schedule does not add up to the depreciable base',
    REGISTER_ABOVE_LEDGER: 'Register above the ledger',
    REGISTER_BELOW_LEDGER: 'Register below the ledger',
  },
  observations: {
    AT03_SCOPE_UNRESOLVED: 'Book functional currency or period not resolved',
    AT03_PENDING_BEFORE_PERIOD: 'Pending instalments from earlier competências',
    AT03_PENDING_NOT_YET_DUE: 'Instalments of the next competência, not yet due',
    AT03_MEMO_INSTALMENTS_MEASURED: 'Instalments computed on memo books, not posted',
    AT03_ACCOUNT_UNMAPPED: 'Assets with no cost or accumulated depreciation account mapped',
    AT03_REGISTER_COST_UNMEASURABLE: 'Assets whose book cost could not be measured',
    AT03_LEDGER_ACCOUNT_RESTRICTED: 'Restricted accounts left out of the comparison',
    AT03_JOURNAL_RESTRICTED: 'Instalments with a protected journal left out of the comparison',
    AT03_REGISTER_NOT_MEASURABLE_AT_CUTOFF:
      'Assets changed after the period end, left out of the ledger comparison',
    AT03_FOREIGN_CURRENCY_NOT_MEASURED:
      'Amounts of assets measured in another currency, with no functional amount',
    AT03_SCHEDULE_BASE_UNDETERMINED:
      'Schedules of migrated assets where it is unknown if the base includes the opening depreciation',
  },
  asset: 'Asset {{code}}',
  account: 'Account {{code}}',
  openAsset: 'Open asset',
  listTruncated: 'Showing {{shown}} of {{total}} findings.',
};
